import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import IntlyVideo from 'components/intly-video';
import lib from './components/lib';
import matterAnimation from './components/matter-animation';
import Animate from './components/animate';
import LazyScroll from './components/lazyScroll';
import HighlightAnchorNav from './components/HighlightAnchorNav';
import ContCards from './components/cont-cards';
import CanDrag from './components/can-drag';
import CalendlyPopupLinks from './components/calendly-popup-links';
import PreventEmptyHashLinks from './components/prevent-empty-hash-links';

if(lib.qs('#canvas')) {
    matterAnimation();    
}


new Animate();
new LazyScroll();
new ContCards();
new CanDrag();
new CalendlyPopupLinks();
new PreventEmptyHashLinks();

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.store('carousel', {
    currentSlide: 1,
});
Alpine.start();

jQuery(function($) {
    Components.init();
    Plugins.init();
    slickCounter($);
    (new HighlightAnchorNav).init(); /* Script Highlights The Nav When Reaching an Anchor Point */
});


// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

// Initialize Vimeo
document.querySelectorAll(".intly-video").forEach((root) => {
    new IntlyVideo(root);
});


const slickCounter = ($) => {
        const counterContainer = document.querySelector('.carousel-container[data-block-id]');

        if(!counterContainer) {
            return;
        }

        const blockId = counterContainer.getAttribute('data-block-id');
        const slickElement = document.querySelector(`.carousel-container[data-block-id="${blockId}"] ul`);

        if(!slickElement) {
            return;
        }

        $(slickElement).on('afterChange', function(event, slick, currentSlide){
            if(!currentSlide) {
                currentSlide = 0
            }

            currentSlide = currentSlide + 1;

            Alpine.store('carousel').currentSlide = currentSlide;
        });

        $(slickElement).slick({
            arrows: true,
            prevArrow: '.arrow-prev-' + blockId, // Ensure this matches your HTML class
            nextArrow: '.arrow-next-' + blockId, // Ensure this matches your HTML class
            adaptiveHeight: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            speed: 200,
            rows: 1
        });
}
